import React, { useMemo, useState, useEffect, useRef, useContext, useCallback } from "react";
import { useDispatch } from "react-redux";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MenuItem, IconButton, Select } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import { Button, Input } from "abs-ui-components";

import { myFleetActions } from "../../../store/myFleet/myFleet.slice";
import { ClaimsContext } from "../../../services/ClaimsService";
import { FeatureType } from "../../../constants/FeatureToggles";

const ConsumerRegistryFormGroup = (props,isReportTab) => {
	const { userHasFeature, userFeaturesAreLoaded } = useContext(ClaimsContext);
	const dispatch = useDispatch();
	const [isHidden, setIsHidden] = useState(false);
	const selectRef = useRef(null);
	const [data, setData] = useState([
		{
			id: 1,
			consumerCode: "ME",
			consumerName: "Main Engine",
			monitoringMethod: null,
			mrvMonitoringMethod: null,
			emissionSourceType: "",
			emissionSourceClass: "",
			emissionSourceTypeId: null,
			emissionSourceClassId: null,
			ukEtsMonitoringMethod: "",
		    UKETSConsumerMonitoringMethodMstId: null,
		    ukEtsLevelOfUncertainity: "",	
		},
		{
			id: 2,
			consumerCode: "AE",
			consumerName: "Aux Engine",
			monitoringMethod: null,
			mrvMonitoringMethod: null,
			emissionSourceType: "",
			emissionSourceClass: "",
			emissionSourceTypeId: null,
			emissionSourceClassId: null,
			ukEtsMonitoringMethod: "",
		    UKETSConsumerMonitoringMethodMstId: null,
		    ukEtsLevelOfUncertainity: "",
		},
		{
			id: 3,
			consumerCode: "BOILER",
			consumerName: "Boiler",
			monitoringMethod: null,
			mrvMonitoringMethod: null,
			emissionSourceType: "",
			emissionSourceClass: "",
			emissionSourceTypeId: null,
			emissionSourceClassId: null,
			ukEtsMonitoringMethod: "",
		    UKETSConsumerMonitoringMethodMstId: null,
		    ukEtsLevelOfUncertainity: "",
		},
	]);

	const [isDataModified, setIsDataModified] = useState(false);
	const [errors, setErrors] = useState({
		code: [],
		name: [],
	});

	const formatUncertainty = (value) => {
		if (value === null || value === undefined || value === "") {
			return "";
		}
		const num = Number(value);
		return Number.isNaN(num) ? "" : num.toFixed(5);
	};

	const toDecimalOrNull = (val) => {
		if (val === null || val === undefined || val === "") {
			return null;
		}

		const num = Number(val);

		return isNaN(num) ? null : num;
	};
	const consumerMethods = useMemo(
		() =>
			props.masterData?.[6]?.GetConsumerMonitoringMethod
				? [
						...props.masterData[6]?.GetConsumerMonitoringMethod.map((e) => ({
							...e,
							value: e.Value,
							label: e.Value,
							ConsumerMonitoringMethodMstId: e.ConsumerMonitoringMethodMstId,
						})),
				  ]
				: [],
		[props.masterData?.[6]?.GetConsumerMonitoringMethod]
	);

	const consumerMethods1 = useMemo(
		() =>
			props.masterData?.[6]?.GetConsumerMonitoringMethod
				? [
						...props.masterData[6]?.GetConsumerMonitoringMethod.map((e) => ({
							...e,
							value: e.Value,
							label: e.Value,
							ConsumerMonitoringMethodMstId: e.ConsumerMonitoringMethodMstId,
						})),
				  ]
				: [],
		[props.masterData?.[6]?.GetConsumerMonitoringMethod]
	);

	const mrvMonitoringMethods = useMemo(
		() =>
			props.masterData?.[7]?.GetMrvConsumerMonitoringMethod
				? [
						...props.masterData[7]?.GetMrvConsumerMonitoringMethod.map((e) => ({
							...e,
							value: e.Value,
							label: e.Value,
							ConsumerMrvMonitoringMethodMstId: e.MrvConsumerMonitoringMethodMstId,
						})),
				  ]
				: [],
		[props.masterData?.[7]?.GetMrvConsumerMonitoringMethod]
	);

	const emissionSourceType = useMemo(
		() =>
			props.masterData?.[8]?.GetEmissionSourceType
				? [
						...props.masterData[8]?.GetEmissionSourceType.map((e) => ({
							...e,
							value: e.Value,
							label: e.Value,
							emissionSourceTypeId: e?.EmissionSourceTypeId,
						})),
				  ]
				: [],
		[props.masterData?.[8]?.GetEmissionSourceType]
	);

	const emissionSourceClass = useMemo(
		() =>
			props.masterData?.[9]?.GetEmissionSourceClass
				? [
						...props.masterData[9]?.GetEmissionSourceClass.map((e) => ({
							...e,
							value: e.Value,
							label: e.Value,
							emissionSourceClassId: e?.EmissionSourceClassId,
						})),
				  ]
				: [],
		[props.masterData?.[9]?.GetEmissionSourceClass]
	);

	const ukEtsMonitoringMethods = useMemo(
	() =>
		props.masterData?.[10]?.GetUKETSMonitoringMethod
			? props.masterData[10].GetUKETSMonitoringMethod.map((item) => ({
					value: item.Value,
					label: item.Value,
					UKETSConsumerMonitoringMethodMstId:
						item.UKETSConsumerMonitoringMethodMstId,
			  }))
			: [],
	    [props.masterData?.[10]?.GetUKETSMonitoringMethod]
    );

	useEffect(() => {
		if (!props?.vesselMstId && !isDataModified) {
			const payloadData = data.map((item) => ({
				consumerType: item.consumerCode,
				consumerName: item.consumerName,
				consumerMonitoringMethodMstId: null,
				consumerMrvMonitoringMethodMstId: null,
				emissionSourceTypeId: item.emissionSourceTypeId ?? null,
				emissionSourceClassId: item.emissionSourceClassId ?? null,
				UKETSConsumerMonitoringMethodMstId: item.UKETSConsumerMonitoringMethodMstId ?? null,
				UKETSLevelOfUncertainity: toDecimalOrNull(item.ukEtsLevelOfUncertainity),
			}));
			dispatch(
				myFleetActions.saveConsumerRegistryPayload({
					consumerRegistryPayload: JSON.stringify(payloadData),
				})
			);
		}
	}, []);

	const handleScroll = useCallback(() => {
		if (selectRef.current) {
			const rect = selectRef.current.getBoundingClientRect();
			if (rect.top <= 0 || rect.bottom >= window.innerHeight) {
				setIsHidden(true);
			} else {
				setIsHidden(false);
			}
		}
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	useEffect(() => {
		if (!isDataModified && props?.vesselData?.VesselConsumerDtls?.length > 0) {
			const payload = props.vesselData.VesselConsumerDtls.map((consumer) => {
				return {
					consumerType: consumer.ConsumerType,
					consumerName: consumer.ConsumerName,
					consumerMonitoringMethodMstId: consumer.ConsumerMonitoringMethodMstId,
					consumerMrvMonitoringMethodMstId: consumer.ConsumerMrvMonitoringMethodMstId,
					emissionSourceTypeId: consumer.EmissionSourceTypeId ?? null,
					emissionSourceClassId: consumer.EmissionSourceClassId ?? null,
					UKETSConsumerMonitoringMethodMstId: consumer.UKETSConsumerMonitoringMethodMstId ?? null,
					UKETSLevelOfUncertainity: toDecimalOrNull(consumer.UKETSLevelOfUncertainity),
				};
			}).filter(Boolean);

			if (payload.length > 0) {
				dispatch(
					myFleetActions.saveConsumerRegistryPayload({
						consumerRegistryPayload: JSON.stringify(payload),
					})
				);
			}
		}
	}, [props?.vesselData?.VesselConsumerDtls, dispatch]);

	// fetching the API response to the table
	useEffect(() => {
		if (props?.vesselMstId && props?.vesselData?.VesselConsumerDtls) {
			const filteredConsumerMethods = props.masterData[6]?.GetConsumerMonitoringMethod || [];
			const filteredMrvConsumerMethods = mrvMonitoringMethods;
			const filteredEmissionSourceTypes = emissionSourceType || [];
			const filteredEmissionSourceClasses = emissionSourceClass || [];
			const filteredUkEtsMonitoringMethods = ukEtsMonitoringMethods || [];

			//default consumers list
			const defaultConsumers = [
				{
					id: 1,
					consumerCode: "ME",
					consumerName: "Main Engine",
					monitoringMethod: null,
					mrvMonitoringMethod: null,
					emissionSourceType: "",
					emissionSourceClass: "",
					emissionSourceTypeId: null,
					emissionSourceClassId: null,
					ukEtsMonitoringMethod: "",
                    UKETSConsumerMonitoringMethodMstId: null,
                    ukEtsLevelOfUncertainity: "",
				},
				{
					id: 2,
					consumerCode: "AE",
					consumerName: "Aux Engine",
					monitoringMethod: null,
					mrvMonitoringMethod: null,
					emissionSourceType: "",
					emissionSourceClass: "",
					emissionSourceTypeId: null,
					emissionSourceClassId: null,
					ukEtsMonitoringMethod: "",
                    UKETSConsumerMonitoringMethodMstId: null,
                    ukEtsLevelOfUncertainity : "",
				},
				{
					id: 3,
					consumerCode: "BOILER",
					consumerName: "Boiler",
					monitoringMethod: null,
					mrvMonitoringMethod: null,
					emissionSourceType: "",
					emissionSourceClass: "",
					emissionSourceTypeId: null,
					emissionSourceClassId: null,
					ukEtsMonitoringMethod: "",
                    UKETSConsumerMonitoringMethodMstId: null,
                    ukEtsLevelOfUncertainity : "",
				},
			];

			//method to get ConsumerMonitoringMethodMstId for user selected monitoring method for default consumers
			const updatedDefaultConsumers = defaultConsumers.map((item) => {
				const matchingMethod = props?.vesselData?.VesselConsumerDtls.find((method) => method.ConsumerType === item.consumerCode);

				const matchingObject = filteredConsumerMethods.find(
					(item) => item?.ConsumerMonitoringMethodMstId === matchingMethod?.ConsumerMonitoringMethodMstId
				);

				const matchingMrvObject = filteredMrvConsumerMethods.find(
					(item) => item?.ConsumerMrvMonitoringMethodMstId === matchingMethod?.ConsumerMrvMonitoringMethodMstId
				);
				const emissionType = filteredEmissionSourceTypes.find((method) => method.emissionSourceTypeId === matchingMethod?.EmissionSourceTypeId);

				const emissionClass = filteredEmissionSourceClasses.find((method) => method.emissionSourceClassId === matchingMethod?.EmissionSourceClassId);
				const ukEtsMonitoringMethod = filteredUkEtsMonitoringMethods.find(
					(method) => method.UKETSConsumerMonitoringMethodMstId === matchingMethod?.UKETSConsumerMonitoringMethodMstId
				);
				return {
					...item,
					monitoringMethod: matchingObject ? matchingObject.Value : "",
					consumerMonitoringMethodMstId: matchingObject?.ConsumerMonitoringMethodMstId,
					mrvMonitoringMethod: matchingMrvObject ? matchingMrvObject.Value : "",
					consumerMrvMonitoringMethodMstId: matchingMrvObject?.ConsumerMrvMonitoringMethodMstId,
					emissionSourceType: emissionType?.value || "",
					emissionSourceTypeId: emissionType?.emissionSourceTypeId || null,
					emissionSourceClass: emissionClass?.value || "",
					emissionSourceClassId: emissionClass?.emissionSourceClassId || null,
					ukEtsMonitoringMethod: ukEtsMonitoringMethod?.value || "",
					UKETSConsumerMonitoringMethodMstId: ukEtsMonitoringMethod?.UKETSConsumerMonitoringMethodMstId ?? null,
					ukEtsLevelOfUncertainity: formatUncertainty(matchingMethod?.UKETSLevelOfUncertainity),
				};
			});

			//method to get ConsumerMonitoringMethodMstId for user selected monitoring method for saved consumers
			const updatedData = props.vesselData.VesselConsumerDtls.map((item) => {
				const matchingMethod = filteredConsumerMethods.find((method) => method.ConsumerMonitoringMethodMstId === item.ConsumerMonitoringMethodMstId);
				const matchingMrvMethod = filteredMrvConsumerMethods.find(
					(method) => method.ConsumerMrvMonitoringMethodMstId === item.ConsumerMrvMonitoringMethodMstId
				);
				const emissionType = filteredEmissionSourceTypes.find((method) => method.emissionSourceTypeId === item.EmissionSourceTypeId);

				const emissionClass = filteredEmissionSourceClasses.find((method) => method.emissionSourceClassId === item.EmissionSourceClassId);
				const ukEtsMonitoringMethod = filteredUkEtsMonitoringMethods.find(
					(method) => method.UKETSConsumerMonitoringMethodMstId === item?.UKETSConsumerMonitoringMethodMstId
				);
				return {
					id: item.VesselConsumerDtlId,
					consumerCode: item.ConsumerType,
					consumerName: item.ConsumerName,
					monitoringMethod: matchingMethod ? matchingMethod.Value : "",
					consumerMonitoringMethodMstId: matchingMethod?.ConsumerMonitoringMethodMstId,
					mrvMonitoringMethod: matchingMrvMethod ? matchingMrvMethod.Value : "",
					consumerMrvMonitoringMethodMstId: matchingMrvMethod?.ConsumerMrvMonitoringMethodMstId,
					emissionSourceType: emissionType?.value || "",
					emissionSourceTypeId: emissionType?.emissionSourceTypeId || null,
					emissionSourceClass: emissionClass?.value || "",
					emissionSourceClassId: emissionClass?.emissionSourceClassId || null,
					ukEtsMonitoringMethod: ukEtsMonitoringMethod?.value || "",
					UKETSConsumerMonitoringMethodMstId:ukEtsMonitoringMethod?.UKETSConsumerMonitoringMethodMstId?? null,
					ukEtsLevelOfUncertainity: formatUncertainty(item.UKETSLevelOfUncertainity),
				};
			});

			//merging the default and saved consumers
			const mergedData = [...updatedDefaultConsumers, ...updatedData.filter((item) => !["ME", "AE", "BOILER"].includes(item.consumerCode))];

			setData(mergedData);
		}
	}, [props.vesselMstId, userFeaturesAreLoaded, props.vesselData?.VesselConsumerDtls, props.masterData]);

	var isEmissionSourceTypeEnabled= userFeaturesAreLoaded && userHasFeature(FeatureType.EmissionSourceType);

	const columns = useMemo(
		() => [
			{
				accessorKey: "consumerCode",
				header: "Consumer Code",
				Cell: ({ cell, row }) => {
					const error = errors?.code[row.index];
					const index = row.index;
					const consumerCode = cell.getValue()?.toUpperCase();
					const restrictedConsumers = ["ME", "AE", "BOILER"];
					// condition for disabled the consumer code field
					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerType?.toUpperCase() === row?.original?.consumerCode?.toUpperCase()
							);

					return (
						<>
							<Input
								fullWidth
								value={cell.getValue() || ""}
								onChange={(e) => handleInputChange(row.index, "consumerCode", e)}
								autoFocus={false}
								disabled={shouldDisable}
								className="input-height field-to-uppercase"
								style={{
									backgroundColor: shouldDisable ? "#e0e0e0" : "",
								}}
							/>
							{error && <div style={{ color: "red", fontSize: "0.8em" }}>{error}</div>}
						</>
					);
				},
			},
			{
				accessorKey: "consumerName",
				header: "Consumer Name",
				Cell: ({ cell, row }) => {
					const index = row.index;
					const error = errors.name[row.index];
					const consumerName = cell.getValue();
					const restrictedConsumers = ["Main Engine", "Aux Engine", "Boiler"];

					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerName)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerName?.toUpperCase() === row?.original?.consumerName?.toUpperCase()
							);
					return (
						<>
							<Input
								fullWidth
								value={cell.getValue() || ""}
								onChange={(e) => handleInputChange(row.index, "consumerName", e)}
								autoFocus={false}
								disabled={shouldDisable}
								className="input-height"
								style={{
									backgroundColor: shouldDisable ? "#e0e0e0" : "",
								}}
							/>
							{error && <div style={{ color: "red", fontSize: "0.8em" }}>{error}</div>}
						</>
					);
				},
			},
			{
				accessorKey: "monitoringMethod",
				header: "IMO Monitoring Method",
				Cell: ({ cell, row }) => {
					const index = row.index;
					const consumerCode = cell.getValue()?.toUpperCase();
					const restrictedConsumers = ["ME", "AE", "BOILER"];
					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerType?.toUpperCase() === row?.original?.consumerCode?.toUpperCase()
							);

					const shouldOptionFieldHide =
						["ME", "AE", "BOILER"].includes(row.original.consumerCode && row.original.monitoringMethod) ||
						(props?.vesselMstId && props?.vesselData?.VesselConsumerDtls?.some((item) => item.ConsumerType === row.original.consumerCode));

					return (
						<div
							style={{
								display: "flex",
								gap: "8px",
							}}
						>
							<Select
								ref={selectRef}
								fullWidth
								value={cell.getValue() || null}
								onChange={(e) => handleInputChange(row.index, "monitoringMethod", e.target.value)}
								disabled={props?.isReportTab === true ? true : props?.disabled}
								variant="outlined"
								size="small"
								sx={{
									width: "12rem",
									flex: 1,
									backgroundColor: props?.disabled ? "#e0e0e0" : "rgb(241, 241, 242)",
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											border: "none",
										},
									},
									"& .MuiSelect-icon": {
										width: "0.6em !important",
										height: "0.6em !important",
										color: "rgb(0, 42, 78) !important",
									},
									"& input": {
										fontSize: cell.getValue() ? "12px" : "inherit",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									"& .MuiSelect-select span::before": {
										content: "'Please Select'",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									input: {
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
										"&::placeholder": {
											opacity: 1,
										},
									},
								}}
								MenuProps={{
									disableScrollLock: true,
									disablePortal: false,
									sx: {
										width: "100%",
										display: isHidden ? "none" : "block",
									},
								}}
							>
								{(shouldOptionFieldHide ? consumerMethods1 : consumerMethods).map((method) => (
									<MenuItem
										key={method.value}
										value={method.value}
										sx={{
											fontSize: "12px",
										}}
									>
										{method.label}
									</MenuItem>
								))}
							</Select>
						</div>
					);
				},
			},
			{
				accessorKey: "mrvMonitoringMethod",
				header: "EU MRV Monitoring Method",
				Cell: ({ cell, row }) => {
					const index = row.index;
					const consumerCode = cell.getValue()?.toUpperCase();
					const restrictedConsumers = ["ME", "AE", "BOILER"];
					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerType?.toUpperCase() === row?.original?.consumerCode?.toUpperCase()
							);
					const isCommonConsumers = !["ME", "AE", "BOILER"].includes(row.original.consumerCode) && !shouldDisable;
					const showDeleteIcon = isCommonConsumers && !isEmissionSourceTypeEnabled;
					return (
						<div
							style={{
								display: "flex",
								gap: "8px",
							}}
						>
							<Select
								ref={selectRef}
								fullWidth
								value={cell.getValue() || null}
								onChange={(e) => handleInputChange(row.index, "mrvMonitoringMethod", e.target.value)}
								disabled={props?.isReportTab === true ? true : props?.disabled}
								variant="outlined"
								size="small"
								sx={{
									width: "12rem",
									flex: 1,
									backgroundColor: props?.disabled ? "#e0e0e0" : "rgb(241, 241, 242)",
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											border: "none",
										},
									},
									"& .MuiSelect-icon": {
										width: "0.6em !important",
										height: "0.6em !important",
										color: "rgb(0, 42, 78) !important",
									},
									"& input": {
										fontSize: cell.getValue() ? "12px" : "inherit",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									"& .MuiSelect-select span::before": {
										content: "'Please Select'",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									input: {
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
										"&::placeholder": {
											opacity: 1,
										},
									},
								}}
								MenuProps={{
									disableScrollLock: true,
									disablePortal: false,
									sx: {
										width: "100%",
										display: isHidden ? "none" : "block",
									},
								}}
							>
								{mrvMonitoringMethods.map((method) => (
									<MenuItem
										key={method.value}
										value={method.value}
										sx={{
											fontSize: "12px",
										}}
									>
										{method.label}
									</MenuItem>
								))}
							</Select>

							{showDeleteIcon && (
								<IconButton onClick={() => handleRemoveRow(row.index)} color="error" size="small">
									<DeleteIcon />
								</IconButton>
							)}
						</div>
					);
				},
			},
			{
				accessorKey: "emissionSourceType",
				header: "Emission Source Type",
				Cell: ({ cell, row }) => {
					const index = row.index;
					const consumerCode = cell.getValue()?.toUpperCase();
					const restrictedConsumers = ["ME", "AE", "BOILER"];
					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerType?.toUpperCase() === row?.original?.consumerCode?.toUpperCase()
							);
					return (
						<div
							style={{
								display: "flex",
								gap: "8px",
							}}
						>
							<Select
								ref={selectRef}
								fullWidth
								value={cell.getValue() || null}
								onChange={(e) => handleInputChange(row.index, "emissionSourceType", e.target.value)}
								disabled={props?.disabled}
								variant="outlined"
								size="small"
								sx={{
									width: "12rem",
									flex: 1,
									backgroundColor: props?.disabled ? "#e0e0e0" : "rgb(241, 241, 242)",
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											border: "none",
										},
									},
									"& .MuiSelect-icon": {
										width: "0.6em !important",
										height: "0.6em !important",
										color: "rgb(0, 42, 78) !important",
									},
									"& input": {
										fontSize: cell.getValue() ? "12px" : "inherit",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									"& .MuiSelect-select span::before": {
										content: "'Please Select'",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									input: {
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
										"&::placeholder": {
											opacity: 1,
										},
									},
								}}
								MenuProps={{
									disableScrollLock: true,
									disablePortal: false,
									sx: {
										width: "100%",
										display: isHidden ? "none" : "block",
									},
								}}
							>
								{emissionSourceType.map((method) => (
									<MenuItem
										key={method.value}
										value={method.value}
										sx={{
											fontSize: "12px",
										}}
									>
										{method.label}
									</MenuItem>
								))}
							</Select>
						</div>
					);
				},
			},
			{
				accessorKey: "emissionSourceClass",
				header: "Emission Source Class",
				Cell: ({ cell, row }) => {
					const index = row.index;
					const consumerCode = cell.getValue()?.toUpperCase();
					const restrictedConsumers = ["ME", "AE", "BOILER"];
					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerType?.toUpperCase() === row?.original?.consumerCode?.toUpperCase()
							);
					const isCommonConsumers = !["ME", "AE", "BOILER"].includes(row.original.consumerCode) && !shouldDisable;
					const showDeleteIcon = isCommonConsumers && isEmissionSourceTypeEnabled;
					return (
						<div
							style={{
								display: "flex",
								gap: "8px",
							}}
						>
							<Select
								ref={selectRef}
								fullWidth
								value={cell.getValue() || null}
								onChange={(e) => handleInputChange(row.index, "emissionSourceClass", e.target.value)}
								disabled={props?.disabled}
								variant="outlined"
								size="small"
								sx={{
									width: "12rem",
									flex: 1,
									backgroundColor: props?.disabled ? "#e0e0e0" : "rgb(241, 241, 242)",
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											border: "none",
										},
									},
									"& .MuiSelect-icon": {
										width: "0.6em !important",
										height: "0.6em !important",
										color: "rgb(0, 42, 78) !important",
									},
									"& input": {
										fontSize: cell.getValue() ? "12px" : "inherit",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									"& .MuiSelect-select span::before": {
										content: "'Please Select'",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									input: {
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
										"&::placeholder": {
											opacity: 1,
										},
									},
								}}
								MenuProps={{
									disableScrollLock: true,
									disablePortal: false,
									sx: {
										width: "100%",
										display: isHidden ? "none" : "block",
									},
								}}
							>
								{emissionSourceClass.map((method) => (
									<MenuItem
										key={method.value}
										value={method.value}
										sx={{
											fontSize: "12px",
										}}
									>
										{method.label}
									</MenuItem>
								))}
							</Select>

							{showDeleteIcon && (
								<IconButton onClick={() => handleRemoveRow(row.index)} color="error" size="small">
									<DeleteIcon />
								</IconButton>
							)}
						</div>
					);
				},
			},
			{
				accessorKey: "ukEtsMonitoringMethod",
				header: "UK ETS Monitoring Method",

				Cell: ({ cell, row }) => {
					const index = row.index;
					const consumerCode = cell.getValue()?.toUpperCase();
					const restrictedConsumers = ["ME", "AE", "BOILER"];
					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some(
								(item, i) => index <= i && item?.ConsumerType?.toUpperCase() === row?.original?.consumerCode?.toUpperCase()
							);
					const isCommonConsumers = !["ME", "AE", "BOILER"].includes(row.original.consumerCode) && !shouldDisable;
					const showDeleteIcon = isCommonConsumers && isEmissionSourceTypeEnabled;
					return (
						<div
							style={{
								display: "flex",
								gap: "8px",
							}}
						>
							<Select
								ref={selectRef}
								fullWidth
								value={cell.getValue() || ""}
								onChange={(e) => handleInputChange(row.index, "ukEtsMonitoringMethod", e.target.value)}
								disabled={props?.isReportTab === true ? true : props?.disabled}
								displayEmpty
								variant="outlined"
								size="small"
								sx={{
									width: "12rem",
									flex: 1,
									backgroundColor: props?.disabled ? "#e0e0e0" : "rgb(241, 241, 242)",
									"& .MuiOutlinedInput-root": {
										"& fieldset": {
											border: "none",
										},
									},
									"& .MuiSelect-icon": {
										width: "0.6em !important",
										height: "0.6em !important",
										color: "rgb(0, 42, 78) !important",
									},
									"& input": {
										fontSize: cell.getValue() ? "12px" : "inherit",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									"& .MuiSelect-select span::before": {
										content: "'Please Select'",
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
									},
									input: {
										color: "rgb(0, 42, 78)",
										fontWeight: "bold",
										"&::placeholder": {
											opacity: 1,
										},
									},
								}}
								MenuProps={{
									disableScrollLock: true,
									disablePortal: false,
									sx: {
										width: "100%",
										display: isHidden ? "none" : "block",
									},
								}}
							>
								{ukEtsMonitoringMethods.map((method) => (
									<MenuItem
										key={method.UKETSConsumerMonitoringMethodMstId}
										value={method.value}
										sx={{
											fontSize: "12px",
										}}
									>
										{method.label}
									</MenuItem>
								))}
							</Select>

							{showDeleteIcon && (
								<IconButton onClick={() => handleRemoveRow(row.index)} color="error" size="small">
									<DeleteIcon />
								</IconButton>
							)}
						</div>
					);
				},
			},
			{
				accessorKey: "ukEtsLevelOfUncertainity",
				header: "UK ETS Level of Uncertainty (+/-%)",
				muiTableHeadCellProps: {
					sx: {
						whiteSpace: "nowrap",
						minWidth: "260px",
					},
				},
				Cell: ({ cell, row }) => {
					const index = row.index;
					const consumerCode = row.original?.consumerCode?.toUpperCase();

					const restrictedConsumers = ["ME", "AE", "BOILER"];

					const shouldDisable = !props?.vesselMstId
						? index <= 2 && restrictedConsumers.includes(consumerCode)
						: (props?.vesselMstId ||
								props?.disabled ||
								props?.regulations?.trim() === "EUMRV" ||
								props?.regulations?.trim() === "UKMRV" ||
								props?.regulations?.trim() === "DCS") &&
							props?.vesselData?.VesselConsumerDtls?.some((item, i) => index <= i && item?.ConsumerType?.toUpperCase() === consumerCode);
							const value = cell.getValue();
					return (
						<Input
							value={value ?? ""}
							onChange={(value) => {
								// Allow empty value
								if (value === "") {
									handleInputChange(row.index, "ukEtsLevelOfUncertainity", value);
									return;
								}
								// Positive/negative number with max 5 decimal places
								const regex = /^[]?\d*(\.\d{0,5})?$/;

								if (regex.test(value)) {
									handleInputChange(row.index, "ukEtsLevelOfUncertainity", value);
								}
							}}
							className="input-height"
							disabled={props?.isReportTab === true ? true : props?.disabled}
							autoFocus={false}

						/>
					);
				},
			},
		],
		[data, consumerMethods, mrvMonitoringMethods, emissionSourceType, emissionSourceClass, ukEtsMonitoringMethods, errors, props, isHidden]
	);



	const handleInputChange = useCallback(
		(index, accessor, value) => {
			setIsDataModified(true);

			setData((prevData) => {
				const updatedData = [...prevData];
				const currentRow = { ...updatedData[index] };

				// Handle text input validation for consumerCode and consumerName
				if (accessor === "consumerCode") {
					const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, "");
					if (alphanumericValue.length > 10) return prevData;
					value = alphanumericValue;

					// Update errors asynchronously to prevent UI blocking
					setTimeout(() => {
						setErrors((prevErrors) => {
							const updatedErrors = { ...prevErrors };
							delete updatedErrors.code[index];

							const isDuplicate = prevData.some(
								(row, rowIndex) => value !== "" && row.consumerCode?.toUpperCase() === value?.toUpperCase() && rowIndex !== index
							);

							if (!isNaN(value) && value !== "") {
								updatedErrors.code[index] = "Consumer code should be alpha numeric.";
							}
							if (isDuplicate) {
								updatedErrors.code[index] = "Consumer code already exists.";
							}
							return updatedErrors;
						});
					}, 0);
				}

				if (accessor === "consumerName") {
					const alphanumericValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
					if (alphanumericValue.length > 100) return prevData;
					value = alphanumericValue;

					// Update errors asynchronously
					setTimeout(() => {
						setErrors((prevErrors) => {
							const updatedErrors = { ...prevErrors };
							delete updatedErrors.name[index];
							if (!isNaN(value) && value !== "") {
								updatedErrors.name[index] = "Consumer name should be alpha numeric.";
							}
							return updatedErrors;
						});
					}, 0);
				}
				// Validation for UK ETS Level of Uncertainty (+/- %)
				if (accessor === "ukEtsLevelOfUncertainity") {
					value = String(value ?? "");
					// Allow empty value
					if (value !== "") {
						const regex = /^[+-]?\d*(\.\d{0,5})?$/;
						if (!regex.test(value)) {
							return prevData;
						}
					}
				}

				// Update the field value
				currentRow[accessor] = value;

				// Update IDs for select fields
				const fieldConfigs = {
					monitoringMethod: {
						source: consumerMethods,
						localId: "consumerMonitoringMethodMstId",
						sourceId: "ConsumerMonitoringMethodMstId",
					},
					mrvMonitoringMethod: {
						source: mrvMonitoringMethods,
						localId: "consumerMrvMonitoringMethodMstId",
						sourceId: "ConsumerMrvMonitoringMethodMstId",
					},
					emissionSourceType: {
						source: emissionSourceType,
						localId: "emissionSourceTypeId",
						sourceId: "emissionSourceTypeId",
					},
					emissionSourceClass: {
						source: emissionSourceClass,
						localId: "emissionSourceClassId",
						sourceId: "emissionSourceClassId",
					},
					ukEtsMonitoringMethod: {
						source: ukEtsMonitoringMethods,
						localId: "UKETSConsumerMonitoringMethodMstId",
						sourceId: "UKETSConsumerMonitoringMethodMstId",
					},
				};

				if (fieldConfigs[accessor]) {
					const { source, localId, sourceId } = fieldConfigs[accessor];
					const selectedItem = source?.find((item) => item.value === value);
					currentRow[localId] = selectedItem?.[sourceId] ?? null;
				}

				updatedData[index] = currentRow;

				// Dispatch payload asynchronously
				setTimeout(() => {
					const validData = updatedData.filter((_, idx) => !errors.code?.[idx] && !errors.name?.[idx]);

					const payloadData = validData
						.filter((item) => item.consumerCode?.trim() && item.consumerName?.trim())
						.map((item) => ({
							id: item.id,
							consumerType: item.consumerCode?.toUpperCase(),
							consumerName: item.consumerName,
							consumerMonitoringMethodMstId: item.consumerMonitoringMethodMstId ?? null,
							consumerMrvMonitoringMethodMstId: item.consumerMrvMonitoringMethodMstId ?? null,
							emissionSourceTypeId: item.emissionSourceTypeId ?? null,
							emissionSourceClassId: item.emissionSourceClassId ?? null,
							UKETSConsumerMonitoringMethodMstId: item.UKETSConsumerMonitoringMethodMstId ?? null,
							UKETSLevelOfUncertainity: toDecimalOrNull(item.ukEtsLevelOfUncertainity),
							...(props?.vesselMstId && { vesselMstId: props.vesselMstId }),
						}));

					if (payloadData.length > 0) {
						dispatch(
							myFleetActions.saveConsumerRegistryPayload({
								consumerRegistryPayload: JSON.stringify(payloadData),
							})
						);
					}
				}, 0);

				return updatedData;
			});
		},
		[consumerMethods, mrvMonitoringMethods, emissionSourceType, emissionSourceClass, errors, props?.vesselMstId, dispatch]
	);

	const createPayload = useCallback(
		(row) => {
			const selectedMonitoringMethod = consumerMethods.find((method) => method.value === row.monitoringMethod);
			const selectedMrvMonitoringMethod = mrvMonitoringMethods.find((method) => method.value === row.mrvMonitoringMethod);
			const selectedEmissionSourceType = emissionSourceType.find((method) => method.value === row.emissionSourceType);
			const selectedEmissionSourceClass = emissionSourceClass.find((method) => method.value === row.emissionSourceClass);
			const selectedUkEtsMonitoringMethod = ukEtsMonitoringMethods.find((method) => method.value === row.ukEtsMonitoringMethod);

			return {
				id: row.id,
				consumerType: row.consumerCode?.toUpperCase(),
				consumerName: row.consumerName,
				consumerMonitoringMethodMstId: selectedMonitoringMethod?.ConsumerMonitoringMethodMstId ?? null,
				consumerMrvMonitoringMethodMstId: selectedMrvMonitoringMethod?.ConsumerMrvMonitoringMethodMstId ?? null,
				emissionSourceTypeId: selectedEmissionSourceType?.emissionSourceTypeId ?? null,
				emissionSourceClassId: selectedEmissionSourceClass?.emissionSourceClassId ?? null,
				UKETSConsumerMonitoringMethodMstId:
					selectedUkEtsMonitoringMethod?.UKETSConsumerMonitoringMethodMstId ?? row.UKETSConsumerMonitoringMethodMstId ?? null,
				UKETSLevelOfUncertainity: toDecimalOrNull(row.ukEtsLevelOfUncertainity),

				...(props?.vesselMstId && { vesselMstId: props.vesselMstId }),
			};
		},
		[consumerMethods, mrvMonitoringMethods, emissionSourceType, emissionSourceClass,ukEtsMonitoringMethods, props?.vesselMstId]
	);

	const handleRemoveRow = useCallback(
		(index) => {
			setData((prevData) => {
				const updatedData = prevData.filter((_, i) => i !== index);

				// Update errors asynchronously
				setTimeout(() => {
					setErrors((prevErrors) => {
						const updatedErrors = { ...prevErrors };
						delete updatedErrors.code[index];
						delete updatedErrors.name[index];
						return updatedErrors;
					});
				}, 0);

				// Dispatch payload asynchronously
				setTimeout(() => {
					const validData = updatedData.filter((_, idx) => !errors.code?.[idx] && !errors.name?.[idx]);

					const payloadData = validData.filter((item) => item.consumerCode?.trim() && item.consumerName?.trim()).map((item) => createPayload(item));

					if (payloadData.length > 0) {
						dispatch(
							myFleetActions.saveConsumerRegistryPayload({
								consumerRegistryPayload: JSON.stringify(payloadData),
							})
						);
					}
				}, 0);

				return updatedData;
			});
		},
		[createPayload, errors, dispatch]
	);
	const handleAddNewConsumer = () => {
		setData((prevData) => [
			...prevData,
			{
				id: prevData.length > 0 ? Math.max(...prevData.map((d) => d.id)) + 1 : 1,
				consumerCode: "",
				consumerName: "",
				monitoringMethod: "",
				mrvMonitoringMethod: "",
				emissionSourceType: "",
				emissionSourceClass: "",
				emissionSourceTypeId: null,
				emissionSourceClassId: null,
				consumerMonitoringMethodMstId: null,
				consumerMrvMonitoringMethodMstId: null,
				ukEtsMonitoringMethod: "",
				UKETSConsumerMonitoringMethodMstId: null,
				ukEtsLevelOfUncertainity: "",
			},
		]);
	};

	const isDirectCo2MethodVisible = isDirect =>
		col => isDirect || col.accessorKey !== "mrvMonitoringMethod";

	const isEmissionSourceVisible = hasSource =>
		col => hasSource || !["emissionSourceType", "emissionSourceClass"]
			.includes(col.accessorKey);

	const showHideColumns = (
		isEmissionSourceTypeEnabled,
		columns
	) =>
		columns
			.filter(isEmissionSourceVisible(isEmissionSourceTypeEnabled));


	const table = useMaterialReactTable({
		columns: showHideColumns(
			isEmissionSourceTypeEnabled,
			columns
		),
		data,
		enableSorting: false,
		enableRowSelection: false,
		enableColumnPinning: false,
		enableTopToolbar: false,
		enableBottomToolbar: false,
		enableColumnActions: false,
		rowVirtualizerOptions: { overscan: 5 },
		enablePagination: false,
		muiTableHeadCellProps: {
			sx: {
				color: "#fff",
				backgroundColor: "#042a4c",
			},
		},
		muiTablePaperProps: {
			sx: { boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)" },
		},
		muiTableBodyCellProps: {
			sx: { overflow: "visible", position: "relative" },
		},
		muiTableBodyRowProps: {
			sx: {
				verticalAlign: "top",
			},
		},
	});

	return (
		<>
			<div className="custom-table-wrapper consumer-registry mt-3">
				<MaterialReactTable table={table} />
			</div>
			{props?.isReportTab !== true && props?.disabled !== true && (
				<div className="mt-2">
					<Button onClick={handleAddNewConsumer}>
						Add New Consumer
					</Button>
				</div>
			)}
		</>
	);
};


export default ConsumerRegistryFormGroup;
